var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgProjectInfoIcon = function SvgProjectInfoIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "path-1",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "5.-Health-Screening",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "5.4.0-Health-screening-/-Upcoming-/-Reschedule-/-Step-2",
    transform: "translate(-1060.000000, -484.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "5.Health-screening/Upcoming/Patient-info/Filled",
    transform: "translate(1040.000000, 206.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Project",
    transform: "translate(20.000000, 276.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon",
    transform: "translate(0.000000, 2.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Mask"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.125,3.87499996 C16.1600877,3.87607649 16.9989235,4.7149123 17,5.74999997 L17,6.37499996 L18.875,6.37499996 C20.2550872,6.37650697 21.373493,7.4949128 21.375,8.87499996 L21.375,10.75 L2.62499995,10.75 L2.62499995,8.87499996 C2.62650695,7.4949128 3.74491279,6.37650697 5.12499995,6.37499996 L6.99999998,6.37499996 L6.99999998,5.74999997 C7.00107651,4.7149123 7.83991232,3.87607649 8.87499998,3.87499996 Z M15.125,12.3125 C15.125,12.830267 14.705267,13.25 14.1875,13.25 L9.81249999,13.25 C9.29473303,13.25 8.87499998,12.830267 8.87499998,12.3125 L8.87499998,12.15625 C8.87499998,12.0699555 8.80504448,12 8.71874998,12 L2.62499995,12 L2.62499995,17.625 C2.62499995,19.0057119 3.74428808,20.125 5.12499995,20.125 L18.875,20.125 C20.2557119,20.125 21.375,19.0057119 21.375,17.625 L21.375,12 L15.28125,12 C15.1949555,12 15.125,12.0699555 15.125,12.15625 L15.125,12.3125 Z",
    id: "Combined-Shape",
    fill: "currentColor",
    mask: "url(#mask-2)"
  }))))))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgProjectInfoIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/project-info-icon.5f84a801.svg";
export { ForwardRef as ReactComponent };